module.exports = __webpack_public_path__ + "img/icon-alert.aeedff3e.svg";